module.exports = __webpack_public_path__ + "img/edit-grey.40d1a068.svg";